/* -------------------------------------------------------------------------- */
/*                        Card styles                        */
/* -------------------------------------------------------------------------- */

@import './bq-card.variables';

:host {
  @apply block;
}

.bq-card {
  border-style: var(--bq-card--borderStyle);
}
